import { StateObj } from '@utils';
import { createContext } from 'react';

export interface MasterDetailContextProps<T> {
  items: StateObj<T[]>;
  selectedId: StateObj<string | undefined>;
  selectedItem: StateObj<T | undefined>;
  canChangeSelection?: () => Promise<boolean>;
  updateItem: (updatedItem: T, idKey?: keyof T) => void;
  deleteItem: (itemId: string | number, idKey?: keyof T) => void;
  loading: StateObj<boolean>;
  detailLoading: StateObj<boolean>;
  error: StateObj<string | null>;
  refetch: () => void;
  masterMinimized: StateObj<boolean>;
  toggleMasterMinimized: () => void;
}

export const MasterDetailContext =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createContext<MasterDetailContextProps<any> | null>(null);
